import { createAction } from 'typesafe-actions';

import { EOfficeType } from 'shared/types/filters';

export const changeOfficeTypeAction = createAction('filters/officeTypeChanged')<EOfficeType>();
